import type { ScreenModule } from "../../../app/screen-module";
import { SolutionsIndexPage } from "../pages";

export default {
	id: "public.solutions",
	path: "/solutions",
	area: "public",
	navGroup: "サービス案内",
	label: "業種から探す",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: SolutionsIndexPage,
} satisfies ScreenModule;
